/* eslint-disable */
/* This file is auto-generated. Do not edit this file directly. */

/*
 * This file contains the titles of all pages in the app. It is used by
 * the <AutoTitle/> component.
 */

export const titles = {
  '/org/:companyName/auto-vpn': 'Auto VPN',
  '/org/:companyName/auto-vpn/groups': 'Groups - Auto VPN',
  '/org/:companyName/auto-vpn/groups/:groupUUID/:activeTab': 'Group - Auto VPN',
  '/org/:companyName/connect': 'Connect',
  '/org/:companyName/connect/locations': 'Locations - Connect',
  '/org/:companyName/connect/locations/:companyLocationSID': 'Location - Connect',
  '/org/:companyName/hub/:tab': 'Hub',
  '/org/:companyName/hub/cards': 'Cards - Hub',
  '/org/:companyName/hub/list': 'List - Hub',
  '/org/:companyName/hub/map': 'Map - Hub',
  '/org/:companyName/network/:networkSlug/design': 'Design',
  '/org/:companyName/network/:networkSlug/design/floor-plans': 'Floor plans - Design',
  '/org/:companyName/network/:networkSlug/design/floor-plans/:floorPlanUUID': 'Floor plan - Design',
  '/org/:companyName/network/:networkSlug/design/rack-elevations': 'Rack elevations - Design',
  '/org/:companyName/network/:networkSlug/hardware/:tab': 'Hardware',
  '/org/:companyName/network/:networkSlug/hardware/access-points': 'Access points - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/access-points/:uuid/:tab': 'Access point - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/observers': 'Observers',
  '/org/:companyName/network/:networkSlug/hardware/observers/:uuid/:tab': 'Observer - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/power-distribution-units/:tab': 'Power distribution units - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/power-distribution-units/:uuid/:tab': 'Power distribution unit - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/security-appliances/:tab': 'Security appliances - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/security-appliances/:uuid/:tab': 'Security appliance - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/switches/:tab': 'Switches - Hardware',
  '/org/:companyName/network/:networkSlug/hardware/switches/:uuid/:tab': 'Switch - Hardware',
  '/org/:companyName/network/:networkSlug/insights/clients': 'List - Clients - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/:macAddress/:tab': 'Client - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/:macAddress/vulnerabilities/:subtab': 'Client - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/blocked': 'Blocked Clients - Clients - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/connection-events': 'Connection events - Clients - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/vulnerabilities/cpes': 'CPEs - Vulnerabilities - Clients - Insights',
  '/org/:companyName/network/:networkSlug/insights/clients/vulnerabilities/cves': 'CVEs - Vulnerabilities - Clients - Insights',
  '/org/:companyName/network/:networkSlug/insights/host-monitoring': 'Host monitoring - Insights',
  '/org/:companyName/network/:networkSlug/insights/logs': 'Logs - Insights',
  '/org/:companyName/network/:networkSlug/insights/network': 'Network - Insights',
  '/org/:companyName/network/:networkSlug/insights/topology': 'Topology - Insights',
  '/org/:companyName/network/:networkSlug/install-status': 'Install Status',
  '/org/:companyName/network/:networkSlug/network-wide': 'Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/captive-portals': 'Captive portals - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/captive-portals/:uuid/:tab': 'Captive portal - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/captive-portals/add': 'Add captive portal - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/isps': 'ISPs - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/isps/:isp': 'ISP - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/radius-profiles': 'RADIUS Profiles - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/rate-limiting': 'Rate limiting - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/routing/:tab': 'Routing - Network-wide',
  '/org/:companyName/network/:networkSlug/network-wide/vlans': 'VLANs - Network-wide',
  '/org/:companyName/network/:networkSlug/onboarding': 'Onboarding - Network',
  '/org/:companyName/network/:networkSlug/operators/nos-upgrades/:tab': 'Network upgrades - Operator',
  '/org/:companyName/network/:networkSlug/secure-tunnels': 'Secure tunnels',
  '/org/:companyName/network/:networkSlug/secure-tunnels/ipsec': 'IPSec - Secure tunnels',
  '/org/:companyName/network/:networkSlug/secure-tunnels/ipsec/:ipSecTunnelUUID': 'Tunnel - IPSec - Secure tunnels',
  '/org/:companyName/network/:networkSlug/secure-tunnels/vpn': 'Client VPN - Secure tunnels',
  '/org/:companyName/network/:networkSlug/security': 'Security',
  '/org/:companyName/network/:networkSlug/security/dns-security': 'DNS security - Security',
  '/org/:companyName/network/:networkSlug/security/firewall': 'Firewall - Security',
  '/org/:companyName/network/:networkSlug/security/firewall/application': 'Application firewall - Security',
  '/org/:companyName/network/:networkSlug/security/multicast': 'mDNS - Security',
  '/org/:companyName/network/:networkSlug/security/nids/:tab': 'NIDS - Security',
  '/org/:companyName/network/:networkSlug/security/one-to-one-nat': '1:1 NAT - Security',
  '/org/:companyName/network/:networkSlug/security/port-forwarding': 'Port forwarding - Security',
  '/org/:companyName/network/:networkSlug/tools': 'Tools',
  '/org/:companyName/network/:networkSlug/tools/packet-capture-ap/': 'Packet capture',
  '/org/:companyName/network/:networkSlug/tools/packet-capture-observer/': 'Packet capture',
  '/org/:companyName/network/:networkSlug/tools/ping-test/:ispName': 'Ping test',
  '/org/:companyName/network/:networkSlug/tools/speed-test/:ispName': 'Speed test',
  '/org/:companyName/network/:networkSlug/tools/speed-test/results/:uuid': 'Speed test results',
  '/org/:companyName/network/:networkSlug/wireless': 'Wireless',
  '/org/:companyName/network/:networkSlug/wireless/hotspot2.0': 'Hotspot 2.0 - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/radio-profiles': 'Radio profiles - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/ssids': 'SSIDs - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/ssids/:uuid/:tab': 'SSID - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/:tab': 'WIDS - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/allowlist': 'Allowlist - WIDS - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids': 'Honeypot SSIDs - WIDS - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids/:honeypotSSID': 'Honeypot SSID - Honeypot SSIDs - WIDS - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids/:honeypotSSID/:bssid': 'Honeypot SSID - Honeypot SSIDs - WIDS - Wireless',
  '/org/:companyName/network/:networkSlug/wireless/wids/rogue-aps': 'Rogue APs - WIDS - Wireless',
  '/org/:companyName/onboarding': 'Org - Onboarding',
  '/org/:companyName/onboarding/network/:networkSlug': 'Network - Onboarding',
  '/org/:companyName/settings': 'Settings',
  '/org/:companyName/settings/org': 'Org',
  '/org/:companyName/settings/org/:networkSlug/networks': 'Networks - Org',
  '/org/:companyName/settings/org/:networkSlug/notifications/:tab': 'Notifications - Org',
  '/org/:companyName/settings/org/:networkSlug/service-discovery': 'Service discovery - Org',
  '/org/:companyName/settings/org/account': 'Account - Org',
  '/org/:companyName/settings/org/authentication': 'Authentication - Org',
  '/org/:companyName/settings/org/documents': 'Documents - Org',
  '/org/:companyName/settings/org/integrations/:tab': 'Integrations - Org',
  '/org/:companyName/settings/org/users': 'Users - Org',
  '/org/:companyName/settings/user': 'User',
  '/org/:companyName/settings/user/preferences': 'Preferences - User',
  '/org/:companyName/support': 'Support',
  '/toolshed': 'Toolshed',
  '/toolshed/cli/:uuid': 'CLI Login – Toolshed',
  '/toolshed/companies': 'Companies - Toolshed',
  '/toolshed/companies/:slug/networks': 'Networks - Companies - Toolshed',
  '/toolshed/companies/:slug/users': 'Users - Companies - Toolshed',
  '/toolshed/firmware-bulk-upgrader/add': 'Add upgrade - Firmware bulk upgrader - Toolshed',
  '/toolshed/firmware-bulk-upgrader/upgrade-groups': 'Upgrade groups - Firmware bulk upgrader - Toolshed',
  '/toolshed/firmware-bulk-upgrader/upgrades': 'Upgrades - Firmware bulk upgrader - Toolshed',
  '/toolshed/fleetwide-alert-management/:fleetwideAlertUUID': 'Show - Fleetwide alert management - Toolshed',
  '/toolshed/fleetwide-alert-management/alerts': 'Alerts - Fleetwide alert management - Toolshed',
  '/toolshed/fleetwide-alert-management/snoozes': 'Snoozes - Fleetwide alert management - Toolshed',
  '/toolshed/nos-config/:tab': 'NOS config - toolshed',
  '/toolshed/promos': 'Promos - toolshed',
  '/toolshed/providers': 'Providers - Toolshed',
  '/toolshed/providers/:providerUUID/static-rates': 'Provider Static Rates - Toolshed',
  '/toolshed/security-appliances': 'Security appliances - Toolshed',
} as const;